.bx{position:absolute;}